export default "__VITE_ASSET__DcqF7ZTO__"